import { c as _c } from "react/compiler-runtime";
import { getDocumentUploadVaultKeys } from '@onefootprint/core';
import type { Document, DocumentUpload } from '@onefootprint/request-types/dashboard';
import { useObjectUrl } from '@onefootprint/ui';
import type { EntityVault } from '@/types/vault';
const useUploadData = (document, upload, vault) => {
  const $ = _c(7);
  let t0;
  if ($[0] !== document || $[1] !== upload || $[2] !== vault) {
    const keys = getDocumentUploadVaultKeys(document, upload);
    t0 = keys.map(key => vault[key]).find(_temp) ?? vault[upload.identifier];
    $[0] = document;
    $[1] = upload;
    $[2] = vault;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const base64Data = t0 as string;
  const {
    objectUrl,
    mimeType
  } = useObjectUrl(base64Data);
  const isPdf = mimeType === "application/pdf";
  let t1;
  if ($[4] !== isPdf || $[5] !== objectUrl) {
    t1 = {
      objectUrl,
      isPdf
    };
    $[4] = isPdf;
    $[5] = objectUrl;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export default useUploadData;
function _temp(value) {
  return value != null;
}